export default {
  label: 'Active limit orders',
};
